import { UPDATE_PROPERTY } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_PROPERTY.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_PROPERTY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_PROPERTY.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
